import mapboxgl from 'mapbox-gl';

export class Map {

    constructor ( target = '.js-map', key = '', options = {} ) {
        this.target = target;
        this.key = key;

        this.options = {
            ...options
        }
    }

    init () {
        mapboxgl.accessToken = 'pk.eyJ1Ijoicm9vdHN0dWRpbyIsImEiOiJja2w5ZXdrMDkwejR1MnducDNzczBnZmlnIn0.AJIRojvlSL_CWjHLxOGT5w'

        this.$container = document.querySelector( this.target );

        if ( !this.$container ) {
            return false;
        }

        if ( this.$container.dataset.lng && this.$container.dataset.lat && this.$container.dataset.zoom ) {
            this.createSingleMarker();

            this.map.scrollZoom.disable();
            const nav = new mapboxgl.NavigationControl();
            this.map.addControl( nav, 'bottom-right' );
        }

        if ( this.$container.dataset.markers ) {
            this.createMarkers();
        }

    }

    createSingleMarker () {
        const center = [
            this.$container.dataset.lng,
            this.$container.dataset.lat,
        ]

        const zoom = this.$container.dataset.zoom

        this.map = new mapboxgl.Map( {
            container: this.$container,
            style: 'mapbox://styles/mapbox/streets-v11',
            center,
            zoom: zoom,
            attributionControl: false
        } );

        const el = document.createElement( 'div' );
        el.className = 'marker';
        el.style.backgroundImage =
            'url("/resources/images/map-icon.svg")';
        el.style.width = '33px';
        el.style.height = '33px';
        el.style.backgroundSize = '100%';

        const marker = new mapboxgl.Marker( el )
        .setLngLat( center )
        .addTo( this.map );
    }

}
